/**
 * Should be added to entities that are products included in another product (e.g. the 4 included shelves
 * in a pax corner frame). Entities with this component are discregarded when checking if there are
 * invalid products in scene after load.
 */
class IncludedProductComponent {
    constructor() {
        this.typeId = IncludedProductComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
IncludedProductComponent.id = 2078;
export default IncludedProductComponent;
//# sourceMappingURL=IncludedProductComponent.js.map